/** @format */

import template from './gb-image-widget.html';
import './gb-image-widget.scss';

export const GbImageWidgetComponent = {
    template,
    require: {
        gbWidget: '^^',
    },
    controller: class GbImageWidgetComponent {
        constructor($gbAuctionImage) {
            'ngInject';

            this.$gbAuctionImage = $gbAuctionImage;
        }

        getAuctionImage() {
            return this.gbWidget.widget.image;
        }
    },
};
